module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-fir-4a643477bd44c8d7f9f531c5d0b24f53.png";